import script from "./AttachmentIconList.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentIconList.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentIconList.vue?vue&type=style&index=0&id=4c924ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c924ce4"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/.pnpm/vue-cli-plugin-quasar@5.0.2/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QCard,QChip});
